/** форма бренда
 *
 */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { setOnChange } from "components/special";
import { PaymentsServicesTypesSelector } from "components/standart";
import { FloatCurrencies } from "components/special/payments";
import { SwitchValue } from "components/special/forms";

const ContentData = (props) => {
  const { content, setContent } = props;

  const changeContent = setOnChange(content, setContent);

  return (
    <div>
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="name"
            value={content.name || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Payments.TelegramExtensions.token" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="token"
            value={content.token || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="type" />
        </label>
        <div className="col-8">
          <PaymentsServicesTypesSelector value={content.type} setValue={changeContent} />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Payments.Currency" />
        </label>
        <div className="col-8">
          <FloatCurrencies
            _id={content.currencyId}
            multi={false}
            showTitle={true}
            showCount={false}
            className="btn-sm mr-1"
            successHandler={([currencyId = null]) => setContent({ ...content, currencyId })}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, {})(ContentData);
